import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  UrlTree
} from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { first, tap } from "rxjs/operators";
import { AbstractAuthorizationService } from "../authorization/services/abstractAuthorization.service";
import { LogClass, Logger } from "../logger";
import { selectIfCurrentUserIs } from "./../user/state";
import { NavigationService } from "./navigation.service";

@Injectable()
@LogClass({ source: "AdminGuard" })
export class AdminGuard implements CanActivate, CanActivateChild {
  private logger: Logger;

  constructor(
    private store: Store,
    private navigate: NavigationService,
    private authorizationService: AbstractAuthorizationService
  ) {
    this.logger.debug("ctor");
  }

  public canActivate(
    route: ActivatedRouteSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    this.logger.debug("canActivate?", route.url);
    return this.store
      .select(
        selectIfCurrentUserIs((u) => this.authorizationService.isAdmin(u.roles))
      )
      .pipe(
        first(),
        tap((isAdmin) => {
          this.logger.debug("canActivate: " + (isAdmin ? "yes" : "no"));
          if (!isAdmin) {
            this.navigate.toError("Access not allowed!");
          }
          return isAdmin;
        })
      );
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    this.logger.debug("canActivateChild?", childRoute.url);
    return this.canActivate(childRoute);
  }
}
